import {
  operations as rootCauseOperations,
  constants as rootCauseConstants,
} from '@saucelabs/sl-module-root-cause';
import { recordTrack } from '@saucelabs/sl-util-segmentio';

import * as constants from './../failure-analysis/constants';
import actions from './actions';
import * as selectors from './selectors';
import { queryParamSelector } from './../failure-analysis/selectors';

import { operations } from './index';

export const generalOperations = rootCauseOperations.createRootCauseOperations(actions);

export const getRootCauseDetails = ({
  isQueryStringFilter = false,
} = {}) => (dispatch, getState) => (
  dispatch(generalOperations.getRootDetail(
    selectors.rootCausesParamsSelector(getState(), { isQueryStringFilter }),
  ))
);

export const getRootCauseAnnotations = ({ patternId } = {}) => (dispatch, getState) => {
  const rootCauseItem = selectors.rootCauseDataSelector(getState(), { patternId });
  if (!patternId || !rootCauseItem) {
    return Promise.resolve();
  }

  const rootCauseParams = queryParamSelector(getState(), { api: rootCauseItem.get('annotationsURL') });
  return dispatch(generalOperations.getAnnotations(
    { patternId, ...rootCauseParams }, patternId, rootCauseItem,
  ));
};

export const selectTestAndRedirectToRootCauses = (payload) => (dispatch, getState) => {
  const queryParams = selectors.selectTestParamsSelector(getState(), payload);
  return Promise.all([
    dispatch(actions.pushPath(constants.FAILURE_ANALYSIS_PAGE_ROOT_CAUSES_URL, queryParams)),
    dispatch(actions.handleSelectTest(payload.test)),
    dispatch(recordTrack(rootCauseConstants.MIXPANEL_EVENTS.TEST_SELECTED)),
  ]);
};

export const resetTestAndGetRootCauses = (payload, meta) => (dispatch, getState) => {
  const queryParams = selectors.selectTestParamsSelector(getState(), null);
  return Promise.all([
    dispatch(actions.pushPath(constants.FAILURE_ANALYSIS_PAGE_ROOT_CAUSES_URL, queryParams)),
    dispatch(actions.handleResetTest(payload, meta)),
    dispatch(recordTrack(rootCauseConstants.MIXPANEL_EVENTS.TEST_RESET)),
  ]).then(() => dispatch(operations.getRootCauseDetails()));
};

export const loadInitFilters = () => (dispatch, getState) => {
  const selectedTest = selectors.initFilterSelector(getState());
  if (selectedTest?.id) {
    dispatch(actions.handleSelectTest(selectedTest));
  }
  return dispatch(operations.getRootCauseDetails({ isQueryStringFilter: true }));
};

export const updateRootCause = (params) => async (dispatch, getState) => (
  dispatch(actions.updateRootCause({
    ...params,
    ...selectors.ownerFilterSelector(getState()),
  }, params))
);

export const getRootCauseTests = ({
  patternId, includeNextToken = false,
} = {}) => (dispatch, getState) => {
  const rootCauseItem = selectors.rootCauseDataSelector(getState(), { patternId });
  if (!patternId || !rootCauseItem) {
    return Promise.resolve();
  }

  const params = queryParamSelector(getState(), { api: rootCauseItem.get('jobsURL') });
  return dispatch(generalOperations.getTests({
    params: { rootCauseId: patternId, ...params },
    patternId,
    rootCauseItem,
    includeNextToken,
  }));
};

export const getRootCauseAdditionalData = (params) => (dispatch, getState) => {
  const { isDataExists } = selectors.rootCauseAdditionalDataSelector(getState(), params);

  return isDataExists ? Promise.resolve() : (
    Promise.all([
      dispatch(operations.getRootCauseAnnotations(params)),
      dispatch(operations.getRootCauseTests(params)),
    ])
  );
};
